
import React, { useEffect, useState } from 'react';
import { getregister, getregisterfilter, getcaste, getmyprofile, savewishlists, getsavedprofiles } from "./../action/user";
import { useLocation } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
// import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { Circles } from 'react-loader-spinner'
import FavoriteIcon from '@mui/icons-material/Favorite';
import './freesearch.css';
import InfiniteScroll from "react-infinite-scroller";
import { useInfiniteQuery } from "react-query";
import config from "../../lib/config";
import './freesearch.css'
import AOS from 'aos'
import Pagination from '@material-ui/lab/Pagination';
import whyeliteRight from "../../assests/images/whyelite-right.png";
import { toast } from 'react-toastify';

function Freesearch(props) {

    const [registerfilter, setRegisterfilters] = useState([]);
    const [malecount, setMalecount] = useState(0);
    const [femalecount, setFemalecount] = useState(0);
    const [totalProfileCount, setTotalProfileCount] = useState(1);
    const [sexparam, setsexparam] = useState("");
    const [searchsex, setsearchsex] = useState("");
    const search = useLocation().search;
    const [searchparamsf, setsearchparamsf] = useState(search);
    const [Loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);

    // var filterarray="religion="+religion+"&subcaste="+subcaste+"&castename="+castename+"&sex="+sex+"&maritalname="+maritalname;


    // const subcaste = new URLSearchParams(search).get('subcaste');
    // const sex = new URLSearchParams(search).get('sex');
    // const maritalname = new URLSearchParams(search).get('maritalname');
    const [castes, setCastes] = useState([]);


    const fetchPosts = async ({ pageParam = 0 }) => {

        setLoading(true)
        // var filterobj={page:page-1};
        // var filterobj={};
        var filterobj = { page: pageParam };
        const userid = new URLSearchParams(search).get('userid');
        if (userid) {
            filterobj.userid = userid;
        } else {
            const castename = new URLSearchParams(search).get('castename');
            if (castename) {
                filterobj.castename = castename;
            }
            const sexsearch = new URLSearchParams(search).get('sex');
            if (sexsearch) {
                filterobj.sex = sexsearch;
                setsearchsex(sexsearch)
            }
            if (page) {
                filterobj.page = page - 1;
            }

            if (sexparam) {
                filterobj.sex = sexparam;
            }

            // if(userid){

            //           }

            const products = await getregisterfilter(filterobj);
            setTotalProfileCount(products.totalProfileCount)

            const religion = new URLSearchParams(search).get('religion');
            if (religion) {
                filterobj.religion = religion;
            }
            const city = new URLSearchParams(search).get('city');
            if (city) {
                filterobj.city = city;
            }
            const subcaste = new URLSearchParams(search).get('subcaste');
            if (subcaste) {
                filterobj.subcaste = subcaste;
            }
            const castenone = new URLSearchParams(search).get('castenone');
            if (castenone) {
                filterobj.castenone = "Yes";
            }

            const maritalname = new URLSearchParams(search).get('maritalname');
            if (maritalname) {
                filterobj.maritalname = maritalname;
            }
            const c_date = new Date();
            let year = c_date.getFullYear();
            const age1 = new URLSearchParams(search).get('age1');
            if (age1) {
                const g_year = year - age1;

                filterobj.yearto = g_year;
            }

            const age2 = new URLSearchParams(search).get('age2');
            if (age2) {
                const l_year = year - age2;

                filterobj.yearfrom = l_year;
            }

            const educ = new URLSearchParams(search).get('educ');
            if (educ) {
                filterobj.educ = educ;
            }

            const handireason = new URLSearchParams(search).get('handireason');
            if (handireason) {
                filterobj.handireason = "Yes";
            }

            const zodiacname = new URLSearchParams(search).get('zodiacname');
            if (zodiacname) {
                filterobj.zodiacname = zodiacname;
            }

            const starname = new URLSearchParams(search).get('starname');
            if (starname) {
                filterobj.starname = starname;
            }
        }

        console.log(filterobj, "fghjfghjfgdjhg");
        var test = await getregisterfilter(filterobj);
        //   setRegisterfilters(test.userValue);
        //     const response = await fetch(
        //       `https://picsum.photos/v2/list?page=${pageParam}&limit=10`
        //     );
        // const results = await response.json();
        setMalecount(test.Malecount)
        setFemalecount(test.Femaleount)
        setTotalProfileCount(test.totalCount)
        setLoading(false)
        return { results: test.userValue, nextPage: pageParam + 1, totalPages: test.totalCount / 20 || 0 };
    };
    const {
        data,
        isLoading,
        isError,
        hasNextPage,
        refetch,
        fetchNextPage
    } = useInfiniteQuery("posts", fetchPosts, {
        getNextPageParam: (lastPage, pages) => {
            if (lastPage.nextPage < lastPage.totalPages) return lastPage.nextPage;
            return undefined;
        }
    });

    useEffect(() => {
        const sex = new URLSearchParams(search).get('sex');
        if (sex) {
            setsexparam(sex);
        }
    }, [])


    const handleChange = (event, value) => {
        console.log(value, "hariiiiiiiiiiiiiiiiiiii")
        setPage(value);
    };



    const refresh = async () => {
        await refetch();
    }

    useEffect(() => {
        //logout(history)
        refresh();
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        AOS.init({
            // initialise with other settings
            duration: 2000
        });
    }, [sexparam, page]);
    const initialFormValue = {
        sex: "",
    };
    const [formValue, setFormValue] = useState(initialFormValue);
    const [width, setWidth] = useState(window.innerWidth);
    const [height1, setHeight] = useState(window.innerHeight);
    const sexch = [
        { title: "Male", value: "Male" },
        { title: "Female", value: "Female" },
    ];


    const updateDimensions = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }
    useEffect(() => {


        // console.log(width);

        // console.log(height1);
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    });

    const occupations = [
        { title: "CxO / Chairman / Director / President", value: "CxO / Chairman / Director / President" },
        { title: "VP / AVP / GM / DGM", value: "VP / AVP / GM / DGM" },
        { title: "Sr. Manager / Manager", value: "Sr. Manager / Manager" },
        { title: "Consultant / Supervisor / Team Leads", value: "Consultant / Supervisor / Team Leads" },
        { title: "Team Member / Staff", value: "Team Member / Staff" },

        { title: "Air Hostess / Flight Attendant", value: "Air Hostess / Flight Attendant" },
        { title: "Pilot / Co-Pilot", value: "Pilot / Co-Pilot" },

        { title: "Architect", value: "Architect" },
        { title: "Interior Designer", value: "Interior Designer" },
        { title: "Landscape Architect", value: "Landscape Architect" },

        { title: "Animator", value: "Animator" },
        { title: "Commercial Artist", value: "Commercial Artist" },
        { title: "Web / UX Designers", value: "Web / UX Designers" },

        { title: "Beautician", value: "Beautician" },
        { title: "Fashion Designer", value: "Fashion Designer" },
        { title: "Hairstylist", value: "Hairstylist" },
        { title: "Jewellery Designer", value: "Jewellery Designer" },

        { title: "Customer Support / BPO / KPO Professional", value: "Customer Support / BPO / KPO Professional" },

        { title: "IAS / IRS / IES / IFS", value: "IAS / IRS / IES / IFS" },
        { title: "Indian Police Services [IPS]", value: "Indian Police Services [IPS]" },

        { title: "Airforce", value: "Airforce" },
        { title: "Army", value: "Army" },
        { title: "Navy", value: "Navy" },

        { title: "Lecturer", value: "Lecturer" },
        { title: "Professor", value: "Professor" },
        { title: "Research Assistant", value: "Research Assistant" },
        { title: "Research Scholar", value: "Research Scholar" },
        { title: "Teacher", value: "Teacher" },

        { title: "Civil Engineer", value: "Civil Engineer" },
        { title: "Electronics / Telecom Engineer", value: "Electronics / Telecom Engineer" },
        { title: "Mechanical / Production Engineer", value: "Mechanical / Production Engineer" },

        { title: "Chef / Sommelier / Food Critic", value: "Chef / Sommelier / Food Critic" },
        { title: "Catering Professional", value: "Catering Professional" },

        { title: "Software Developer / Programmer", value: "Software Developer / Programmer" },
        { title: "Software Consultant", value: "Software Consultant" },
        { title: "Hardware & Networking professional", value: "Hardware & Networking professional" },

        { title: "Lawyer", value: "Lawyer" },
        { title: "Legal Assistant", value: "Legal Assistant" },

        { title: "Dentist", value: "Dentist" },
        { title: "Doctor", value: "Doctor" },
        { title: "Medical Transcriptionist", value: "Medical Transcriptionist" },
        { title: "Nurse", value: "Nurse" },
        { title: "Pharmacist", value: "Pharmacist" },
        { title: "Physician Assistant", value: "Physician Assistant" },
        { title: "Physiotherapist / Occupational Therapist", value: "Physiotherapist / Occupational Therapist" },
        { title: "Psychologist", value: "Psychologist" },
        { title: "Surgeon", value: "Surgeon" },
        { title: "Veterinary Doctor", value: "Veterinary Doctor" },

        { title: "Merchant Naval Officer", value: "Merchant Naval Officer" },
        { title: "Mariner", value: "Mariner" },

        { title: "Marketing Professional", value: "Marketing Professional" },
        { title: "Sales Professional", value: "Sales Professional" },

        { title: "Biologist / Botanist", value: "Biologist / Botanist" },
        { title: "Physicist", value: "Physicist" },

        { title: "Others", value: "Others" },
    ];

    const educationOptions = [
        { title: "High School", value: "High School" },
        { title: "Higher Secondary", value: "Higher Secondary" },
        { title: "Diploma", value: "Diploma" },
        { title: "Bachelor's Degree", value: "Bachelor's Degree" },
        { title: "Master's Degree", value: "Master's Degree" },
        { title: "MBA", value: "MBA" },
        { title: "MCA", value: "MCA" },
        { title: "B.Tech", value: "B.Tech" },
        { title: "M.Tech", value: "M.Tech" },
        { title: "MBBS", value: "MBBS" },
        { title: "MD", value: "MD" },
        { title: "PhD", value: "PhD" },
        { title: "CA (Chartered Accountant)", value: "CA" },
        { title: "CS (Company Secretary)", value: "CS" },
        { title: "ICWA", value: "ICWA" },
        { title: "LLB", value: "LLB" },
        { title: "LLM", value: "LLM" },
        { title: "B.Arch", value: "B.Arch" },
        { title: "M.Arch", value: "M.Arch" },
        { title: "B.Sc", value: "B.Sc" },
        { title: "M.Sc", value: "M.Sc" },
        { title: "B.Com", value: "B.Com" },
        { title: "M.Com", value: "M.Com" },
        { title: "BA", value: "BA" },
        { title: "MA", value: "MA" },
        { title: "BBA", value: "BBA" },
        { title: "BCA", value: "BCA" },
        { title: "Others", value: "Others" },
    ];

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [savedProfiles, setSavedProfiles] = useState(new Set());

    const getLoggedInData = async () => {
        const token = localStorage.getItem("user_token");
        if (!token) {
            setIsLoggedIn(false);
            return;
        }
        try {
            setIsLoggedIn(true);
            // Fetch saved profiles when user is logged in
            const savedData = await getsavedprofiles();

            console.log("Saved profiles data:", savedData);

            if (savedData?.userValue && Array.isArray(savedData.userValue)) {
                const savedIds = savedData.userValue
                    .map(e => e.wishlists?._id) // ensure only IDs
                    .filter(Boolean); // remove undefined/null

                setSavedProfiles(new Set(savedIds));
            }
        } catch (error) {
            console.error("Error fetching user profile:", error);
            setIsLoggedIn(false);
        }
    };

    useEffect(() => {
        getLoggedInData();
    }, []);

    const notify = () => toast("Saved Successfully!");
    const savefavprofile = async (id) => {
        try {
            await savewishlists(id);
            setSavedProfiles(prev => new Set([...prev, id])); // add ID correctly
            notify();
        } catch (error) {
            console.error("Error saving profile:", error);
        }
    };

    return (
        <>
            <div className="free-b" >
                <div className="container">
                    <div className="text-center" style={{ marginTop: '20px', marginBottom: '80px' }}>
                        <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
                            <div className="col-md-12 prink" style={{ marginTop: '35px' }}>
                                <div className="row">
                                    <div className="col-md-8">
                                        {searchsex ? <div className='hari' style={{ float: 'left', fontSize: "20px", fontWeight: "bolder" }}>{searchsex == "Male" ? <button type="button" onClick={() => setsexparam("Male")} class="btn btn-sa"> Male ({malecount})</button> : <button type="button" onClick={() => setsexparam("Female")} class="btn btn-sa">Female ({femalecount})</button>}</div>
                                            : <div className='hari' style={{ float: 'left', fontSize: "20px", fontWeight: "bolder" }}><button type="button" onClick={() => setsexparam("Male")} class="btn btn-sa"> Male ({malecount})</button> <button type="button" onClick={() => setsexparam("Female")} class="btn btn-sa">Female ({femalecount})</button></div>
                                        }
                                    </div>


                                    {/* <div className="col-md-4">
                     <label style={{ paddingBottom:"8px", fontSize:"18px", fontWeight:"800"}}>தேடுவது </label>
                                        <Autocomplete
                                                options={sexch}
                                                // noOptionsText="Enter to create a new option"
                                                getOptionLabel={(option) => option.title}
                                                onChange={(event, newValue) => {

                                                    setsexparam(newValue.value);

                                                }}
                                                type="text"
                                                name="sex"
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        // label=""
                                                        variant="outlined"
                                                    />
                                                )}
                                            />
                                    </div>  */}
                                </div>
                            </div>
                            {Loading && <div style={{ TextAlign: "center" }}>
                                <Circles className="satta" color="red" height={50} width={50} />
                            </div>}
                            {isLoading ? (
                                <p></p>
                            ) : isError ? (
                                <p>There was an error</p>
                            ) : (
                                // <InfiniteScroll hasMore={hasNextPage} loadMore={fetchNextPage}>
                                <div>
                                    {data.pages.map(page => (
                                        page.results.map((post) => (
                                            <div className="col-md-12 search-result" style={{ marginTop: '35px' }}>
                                                <div className="title row">
                                                    <div className="col-md-6" style={{ paddingLeft: 'unset', fontSize: '17px' }}>
                                                        <p className='name' style={{ fontSize: "16px" }}>{post.userid} <span style={{ fontSize: "18px" }}> - {post.mname}</span></p>
                                                    </div>

                                                    <div className="col-md-6" style={{ paddingRight: 'unset', fontSize: '17px' }}>
                                                        <a href={"/batman/" + post._id} className='buttonsss'>View Profile</a>
                                                        {isLoggedIn && (
                                                            <button
                                                                onClick={() => savefavprofile(post._id)}
                                                                className='drink'
                                                                disabled={savedProfiles.has(post._id)}
                                                            >
                                                                {savedProfiles.has(post._id) ? 'Saved' : 'Save Profile'}
                                                                <FavoriteIcon style={{ fontSize: '14px', margin: "0px 0px 0px 8px" }} />
                                                            </button>
                                                        )}
                                                    </div>

                                                </div>
                                                <hr style={{ marginTop: '-10.1px' }} />
                                                <div className="row " >
                                                    <div className="col-md-2" >
                                                        <a href={"/batman/" + post._id}>
                                                            <img src={post.photopath.length && post.photopath[0] ? config.API + "/images/user/" + post.photopath[0] : post.sex == "Male" ? require('../../assests/images/man.png') : require('../../assests/images/woman.png')} alt="Profile" className="img-responsive" style={{ height: "200px" }} /></a>
                                                    </div>
                                                    <div className="col-md-5 content">

                                                        <table className='Droid Sans' style={{ width: '100%', fontSize: '17px', fontFamily: 'fantasy' }}>

                                                            <tbody>

                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Gender </b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}> {post.sex == 'Male' ? "Male" : "Female"}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Age</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.age = new Date().getFullYear() - post.year + "" + " Yrs"}</td>
                                                                </tr>
                                                                {/* <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Date of birth</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}> {post.dob = post.date + "-" + post.month + "-" + post.year}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Father Name</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', marginLeft: '10px', paddingBottom: "10px", color: "#000000" }}>{post.father_name}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Mother Name</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.mother_name}</td>
                                                                </tr> */}

                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Religion</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.religion}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Caste</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.castename}</td>
                                                                </tr>

                                                                {/* <tr>
                                            <td style={{ color: '#000', textAlign: 'left', paddingBottom:"10px" }}><b>நட்சத்திரம் </b></td>
                                            <td style={{ width: '22px' , paddingBottom:"10px"}}>:</td>
                                            <td style={{ textAlign: 'left', paddingBottom:"10px" }}> {post.starname}</td>
                                        </tr> */}
                                                            </tbody></table>

                                                    </div>
                                                    <div className="col-md-5 content">
                                                        <table className='Droid' style={{ width: '100%', fontSize: '17px' }}>
                                                            <tbody>
                                                                {/* <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Zodiac</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.zodiacname}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Star</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.starname}</td>
                                                                </tr> */}
                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Job</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.occup && (occupations.some(item => item.title === post?.occup) ? post?.occup : post?.occup + " (Others)")}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Education</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.educ && (educationOptions.some(item => item.title === post?.educ) ? post?.educ : post?.educ + " (Others)")}</td>
                                                                </tr>
                                                                {/* <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Height</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}>{post.height}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>District</b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}> {post.city} </td>
                                                                </tr> */}
                                                                <tr>
                                                                    <td style={{ color: '#000', textAlign: 'left', paddingBottom: "10px" }}><b>Sub Caste </b></td>
                                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                                    <td style={{ textAlign: 'left', paddingBottom: "10px", color: "#000000" }}> {post.subcaste}</td>
                                                                </tr>

                                                            </tbody>
                                                        </table>
                                                        <div class="topright-hide" style={{ textAlign: 'right' }}>
                                                            <img src={whyeliteRight} class="whyelite-bottom" alt="Elite Arrow"
                                                                style={{ width: '21%', marginTop: '-35px', marginRight: '-8px' }}
                                                            />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                        ))))}
                                </div>
                                // </InfiniteScroll>
                            )}
                            {!totalProfileCount &&
                                // <div class="empty-state">
                                <div class="empty-state__content">
                                    <div class="empty-state__icon">
                                        <img src={require('../../assests/img/norec.png')} alt="" />
                                    </div>
                                    <div class="empty-state__message">No Matching Profiles.</div>
                                </div>
                                // </div>
                            }
                            <div className="row">
                                <div className="col-12" style={{ TextAlign: "center" }}>
                                    <Pagination count={Math.round((totalProfileCount / 20))} page={page} color="primary" onChange={handleChange} />
                                </div>
                            </div>
                        </div></div>
                </div >
            </div >

        </>
    )
}

export default Freesearch;
